function isRightMobileNum(num) {
    return num && typeof num === 'string' && (/^1[3456789]\d{9}$/).test(num)
}

export default isRightMobileNum